import React from 'react' //{useState}
import NewsCTXList from '../../modules/custom/newctxForm/crudnewcxt'

const NewCTX: React.FC = () => {


  return (
    <NewsCTXList></NewsCTXList>
  )
}

export {NewCTX}
